export const SKFO_REGION_ID = 'f86ac416-349e-420b-9833-031fdcc2d602';
export const SKFO_REGION_SYSNAME = 'skfo';
